<template>
    <div>
        <label v-if="!simple" class="vs-input--label">
            {{ timeLabel }}
        </label>
        <div class="flex flex-nowrap w-full gap-2">
            <vx-time-input
                ref="input"
                :value="currentStartTime"
                required
                class="w-full"
                :clearable="false"
                name="start time"
                is24hr
                v-bind="$attrs"
                v-on="listeners"
                :remove-validation-padding="simple"
                :hide-icon="simple"
            />
            <vx-date-dropdown
                v-model="currentStartDate"
                is-button
                trigger-click
                justify="start"
                align="right"
            />
            <div v-if="singleLine" class="flex gap-2" style="height: 38px">
                <vs-button v-if="!simple" style="width: 150px" @click="setToNow">
                    Set To Now
                </vs-button>
                <slot name="static-options"> </slot>
            </div>
        </div>
        <div
            v-if="!singleLine && !simple"
            class="flex justify-end flex-nowrap w-full gap-2"
            style="height: 38px"
        >
            <vs-button style="width: 150px" @click="setToNow">Set To Now</vs-button>
            <slot name="static-options"> </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'vx-time-date-input',
    props: {
        value: {
            type: [Date, String]
        },
        label: {
            type: String
        },
        singleLine: {
            type: Boolean,
            default: false
        },
        simple: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    watch: {
        currentStartDateTime() {
            this.validate()
        }
    },
    computed: {
        timeStyles() {
            if (this.singleLine) {
                return {
                    width: '180px'
                }
            }
            return {
                width: '100%'
            }
        },
        currentStartDateTime: {
            get() {
                if (!this.value) {
                    return null
                }
                return new Date(this.value)
            },
            set(newValue) {
                this.$emit('input', newValue)
            }
        },
        currentStartDate: {
            get() {
                return this.currentStartDateTime
            },
            set(newValue) {
                var newDate = new Date(this.currentStartDateTime)
                newDate.setFullYear(newValue.getFullYear())
                newDate.setMonth(newValue.getMonth())
                newDate.setDate(newValue.getDate())

                this.currentStartDateTime = newDate
            }
        },
        currentStartTime: {
            get() {
                return this.currentStartDateTime
            },
            set(newValue) {
                var newDate = new Date(this.currentStartDateTime)
                newDate.setHours(newValue.getHours())
                newDate.setMinutes(newValue.getMinutes())
                newDate.setSeconds(newValue.getSeconds())
                newDate.setMilliseconds(newValue.getMilliseconds())

                this.currentStartDateTime = newDate
            }
        },
        listeners() {
            return {
                ...this.$listeners,
                input: this.handleInput
            }
        },
        timeLabel() {
            if (!this.currentStartDateTime) {
                return 'Not Set'
            }
            var original = ''

            if (this.label) {
                original = `${this.label} - `
            }
            var humanized = this.currentStartDateTime.humanize().capitalize()
            var dayOfWeek = this.currentStartDateTime.getDayOfWeek()
            var dayOfMonth = this.currentStartDateTime.getDayOfMonth()
            return `${original}${humanized} (${dayOfWeek} ${dayOfMonth})`
        }
    },
    methods: {
        setToNow() {
            this.currentStartDateTime = new Date()
        },
        focus() {
            this.$refs.input.focus()
        },
        handleInput(v) {
            this.currentStartTime = v
        }
    },
    mounted() {
        // if (!this.value) {
        //     this.setToNow()
        // }
    },
    created() {}
}
</script>

<style lang="scss" scoped></style>
,
